// import Swiper and modules styles
import '../css/swiper.css';

import video from './video.ts';
import cookie from './cookie.ts';
import header from './header_sticky.ts';
import consulta from './modulo_consulta.ts';
import swipersPersonalizados from './swipers_personalizados.ts';
import newsLatter from './newslatter.ts';
import menu from './menu.ts';
import faqs from './faqs.ts';
import idioma from './idioma.ts';
import idiomaSticky from './idioma_sticky.ts';
import animation from './animation.ts';
import animationSchool from './animacion-red-de-escuelas-tecnicas.ts';

video();
menu();
consulta();
newsLatter();
animation();
animationSchool();
cookie();
swipersPersonalizados();
header();
faqs();
idioma();
idiomaSticky();
